import $ from 'jquery';

import Instagram from '../components/Instagram';
import Twitter from '../components/Twitter';

export default class StaticWidgets {
  constructor(instance) {
    this.$el = $(instance.el);
    const $instagram = this.$el.find('[data-widget="instagram"]');
    const $twitter = this.$el.find('[data-widget="twitter"]');

    this.instagram = null;
    if ($instagram.length) {
      this.instagram = new Instagram($instagram);
    }

    this.twitter = null;
    if ($twitter.length) {
      this.twitter = new Twitter($twitter);
    }
  }

  update($el) {
    this.instagram.init($el);
    if (this.twitter) {
      this.twitter.init($el);
    }
  }

  remove() {
    delete (this.twitter != null);

    if (this.instagram) {
      this.instagram.unload();
      delete this.instagram;
    }
  }
}
